var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.72 15.53 15 13.81v5.69a.75.75 0 1 1-1.5 0v-5.69l-1.72 1.72a.75.75 0 1 1-1.06-1.06l3-3a.75.75 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06M15 3.75a8.26 8.26 0 0 0-7.38 4.564 6 6 0 1 0-.87 11.936h3.75a.75.75 0 1 0 0-1.5H6.75a4.5 4.5 0 1 1 .308-8.989A8.3 8.3 0 0 0 6.75 12a.75.75 0 1 0 1.5 0 6.75 6.75 0 1 1 9.45 6.188.75.75 0 1 0 .6 1.374A8.25 8.25 0 0 0 15 3.75"
  })));
};
export default SvgUpload;